<template lang="pug">
  .time-picker-card(:class="[{'active' : active}, {'disabled': schedule.status !== 0  || schedule.quota == 0}]" @click="$emit('clicked')")
    .copy
      .ampm
        .cn {{$t(`date.${ampm}`)}}
        .en {{ampm.toUpperCase()}}
      .range  {{range}}
      .status
        .quota(v-if="schedule.status===0 && schedule.quota>0") 仅剩{{schedule.quota}}
        .closed(v-if="schedule.quota<1 && schedule.status!=1 && schedule.status!=4") 预约名额已满
        .closed(v-if="schedule.status===1") 已过预约时效
        .closed(v-if="schedule.status===4") 已预约该时段
    .check
      icon-check(ref="check")
</template>
<script>
import IconCheck from '@/components/wedgits/IconCheck'
export default {
  name: 'TimePickerCard',
  components: { IconCheck },
  props: { schedule: {}, active: {} },
  data() {
    return {}
  },
  watch: {
    active(val) {
      if (val) {
        this.$refs.check.animeIn()
      } else {
        this.$refs.check.animeOut()
      }
    },
  },
  computed: {
    ampm() {
      return this.schedule.from.getHours() >= 12 ? 'pm' : 'am'
    },
    range() {
      let h1 = this.schedule.from.getHours()
      let m1 = this.schedule.from.getMinutes()
      let h2 = this.schedule.to.getHours()
      let m2 = this.schedule.to.getMinutes()
      return `${h1 >= 10 ? '' : '0'}${h1}:${m1 >= 10 ? '' : '0'}${m1}-${
        h2 >= 10 ? '' : '0'
      }${h2}:${m2 >= 10 ? '' : '0'}${m2}`
    },
  },
  methods: {},
  mounted() {
    console.log()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.time-picker-card
  width: 100%
  height: pxToRem(120)
  margin: 0 auto pxToRem(40) auto
  border-radius: pxToRem(8)
  background: #FFFFFF
  box-shadow:  pxToRem(-7) pxToRem(-7) pxToRem(12) 0 rgba(255,255,255,0.02), pxToRem(-13) pxToRem(-7) pxToRem(16) 0 rgba(252,252,252,0.74), pxToRem(-8) pxToRem(6) pxToRem(12) 0 rgba(252,252,252,0.35), pxToRem(2) pxToRem(9) pxToRem(30) 0 rgba(228,228,228,0.80)
  padding: pxToRem(40)
  display: flex
  justify-content: space-between
  align-items: center
  flex-direction: row
  &.active
    .copy
      color: $cl-blue
    .ampm
      color: $cl-blue
    .range
      color: $cl-blue
    .status
      color: $cl-blue !important
  &.disabled
    pointer-events: none
    box-shadow: inset pxToRem(-6) pxToRem(-3) pxToRem(6) 0 rgba(255,255,255,0.75), inset pxToRem(3) pxToRem(6) pxToRem(6) 0 #E8E8E8, inset pxToRem(4) pxToRem(2) pxToRem(6) 0 #D6D6D6, inset 0 pxToRem(2) pxToRem(4) 0 #E2E2E2
    border-radius: pxToRem(8)
    border: pxToRem(2) #eeeeee solid
    .copy
      color: #cccccc
    .status
      color: #cccccc !important
  .copy
    display: flex
    align-items: center
    flex-direction: row
    color: black
    .ampm
      font-size: pxToRem(24)
      text-align: center
    .range
      font-size: pxToRem(50)
      font-weight: bold
      font-family: "DINAlternate", sans-serif
      margin-left: pxToRem(20)
    .status
      color: #999999
      font-size: pxToRem(24)
      margin-left: pxToRem(38)
  .check
    width: pxToRem(44)
    height: pxToRem(44)
</style>
